import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { API_ENDPOINTS } from "../../utils/api-endpoints";
import { ReactProjectBaseUrl } from "../../utils/Constants";
import "animate.css";
import { axiosFunction } from "../../utils/globalFunctions/axiosFunction";
import { globalSwalFunction } from "../../utils/globalFunctions/globalSwal";
import {
  getApiToken,
  getBranchToken,
  isGeofenchingEnabled,
} from "../../utils/get-token";

const ProductAttribute = ({
  setVariantAvailablity,
  productAttributes,
  setVarientIndex,
  setAttribute,
  setHideButton,
  setVariantInStock,
}) => {
  const selectedProduct = useSelector((state) => state.selectedProduct);

  const [selectedAttributes, setSelectedAttributes] = useState({
    // attribute_value_1: "",
    attribute_value1_: "",
    attribute_value_2: "",
    attribute_value_3: "",
  });
  const getVarientNameByAttributeLength = (index, ...values) => {

    const variantValues = values.slice(0, index);
    return variantValues.join(" / ");
  };
  const setVariantNameFnc = (
    position,
    attributeValue,
    attributeLength,
    defaultVariantName = ""
  ) => {

    setHideButton(true);

    const setSelectedAttributeAndValue = (position, value) => {

      const selectedAttributeName = `attribute_value_${position + 1}`;
      
      setSelectedAttributes((prev) => {
        return {
          ...prev,
          [selectedAttributeName]: value,
        };
      });

      setAttribute((prev) => {
        return {
          ...prev,
          [`attribute${position + 1}`]: value,
        };
      });
    };

    let selectedVariantName = "";

  
      switch (position) {
        case "0":
          setSelectedAttributeAndValue(0, attributeValue, attributeLength);
          selectedVariantName = getVarientNameByAttributeLength(
            attributeLength,
            attributeValue,
            selectedAttributes.attribute_value_2,
            selectedAttributes.attribute_value_3
          );
          break;

        case "1":
          setSelectedAttributeAndValue(1, attributeValue, attributeLength);
          selectedVariantName = getVarientNameByAttributeLength(
            attributeLength,
            selectedAttributes.attribute_value_1,
            attributeValue,
            selectedAttributes.attribute_value_3
          );
          break;

        case "2":
          setSelectedAttributeAndValue(2, attributeValue, attributeLength);
          selectedVariantName = getVarientNameByAttributeLength(
            attributeLength,
            selectedAttributes.attribute_value_1,
            selectedAttributes.attribute_value_2,
            attributeValue
          );
          break;

        default:
          setSelectedAttributes({
            ...selectedAttributes,
            attribute_value_1: "",
            attribute_value_2: "",
            attribute_value_3: "",
          });
          selectedVariantName = "";
          setAttribute((prev) => ({
            ...prev,
            attribute1: null,
            attribute2: null,
            attribute3: null,
          }));
          break;
      }
    
    if (defaultVariantName != "") {
      selectedVariantName = defaultVariantName;
    }
    if (selectedProduct?.productVarient.length > 0) {
      let selectedProductVarientByName = selectedProduct.productVarient.filter(
        (x) => x.varient === selectedVariantName
      );

      if (selectedProductVarientByName.length > 0) {
        for (
          let index = 0;
          index < selectedProduct.productVarient.length;
          index++
        ) {
          if (
            selectedProduct.productVarient[index].productvarientid ===
            selectedProductVarientByName[0].productvarientid
          ) {
            setVarientIndex(index);
          }
        }

        let response = 0.0;
        const callQtyApi = async () => {
          try {
            const token =
              isGeofenchingEnabled() == 1 ? getBranchToken() : getApiToken();
            await axiosFunction(
              token,
              `${ReactProjectBaseUrl}${API_ENDPOINTS.AVAILABLE_QUANTITY}/${selectedProductVarientByName[0].productvarientid}`,
              "GET"
            ).then((res) => {
              if (res) {
                if (res.data) {
                  const productVarientResponse = res.data;
                  if (productVarientResponse.status) {
                    response = productVarientResponse.response;
                    if (response > 0) {
                      setVariantAvailablity(
                        <p className="text-success my-2">In Stock</p>
                      );
                      setVariantInStock(true);
                    } else {
                      globalSwalFunction(
                        "Out of Stock !!!",
                        '<i class="far fa-times-circle text-danger "></i>'
                      );
                      setVariantAvailablity(
                        <p className="text-danger my-2">Out of Stock</p>
                      );
                      setVariantInStock(false);
                    }
                  }
                }
              }
            });
          } catch (error) {}
        };
        callQtyApi();
      } else {
        setVariantInStock(false);
      }
    }
  };

  // added this useEffect to mimic onClick function on radio buttons in Loop
  useEffect(() => {
    const productVariantArray =
      selectedProduct?.currentVariantDetail?.varientName?.split(" / ");

    for (let index = 0; index < productVariantArray?.length; index++) {
      setVariantNameFnc(
        index?.toString(),
        productVariantArray[index],
        productVariantArray?.length,
        index == productVariantArray?.length - 1
          ? selectedProduct?.currentVariantDetail?.varientName
          : "" // will pass the variant name on last iteration to set variant name in that function.. so api will trigger
      );
    }
    // productVariantArray.map(
    //   (selectedProductVariantName, selectedProductVariantNameIndex) => {
    //     setVariantNameFnc(
    //       selectedProductVariantNameIndex.toString(),
    //       selectedProductVariantName,
    //       productVariantArray.length
    //     );
    //     return null;
    //   }
    // );
    // console.log("productVariantArray", productVariantArray);
    // selectedProduct?.productAttributes?.map()

    // setVariantNameFnc(
    //   productAttributeVo.attributePosition,
    //   productAttributeItemVo,
    //   productAttributes.length
    // );
  }, []);

  useEffect(() => {
    if (selectedProduct?.productAttributes?.length > 0) {
    } else {
      setVariantInStock(true);
    }
  }, [selectedProduct]);

  return (
    <>
      {productAttributes?.map((productAttributeVo, parentIndex) => (
        <div key={parentIndex} className="block_size mb-2 flex-column">
          <p
            className="text_specification col-md-5 col-sm-6 mb-2 d-flex align-items-center"
            style={{ fontWeight: "800" }}
          >
            Choose {productAttributeVo.attributeName}
          </p>
          <div className="block_goodColor__allColors d-flex col-md-7 col-sm-6">
            {productAttributeVo.attributeValues.split(",").length > 0 &&
              productAttributeVo.attributeValues
                .split(",")
                .map((productAttributeItemVo, childIndex) => (
                  <div
                    key={childIndex}
                    className=" mb-1 d-flex align-items-center"
                  >
                    <input
                      type="radio"
                      name={`attribute` + (parentIndex + 1)}
                      className="radio_button"
                      id={`attributeName_${productAttributeVo.attributeName}_${parentIndex}_child_${childIndex}`}
                      defaultChecked={selectedProduct?.currentVariantDetail?.varientName
                        ?.split(" / ")
                        ?.includes(productAttributeItemVo)}
                      value={(() => {
                        // return productAttributeItemVo;
                      })()}
                      onClick={() => {
                        setVariantNameFnc(
                          productAttributeVo.attributePosition,
                          productAttributeItemVo,
                          productAttributes.length
                        );
                      }}
                    />
                    <label
                      htmlFor={`attributeName_${productAttributeVo.attributeName}_${parentIndex}_child_${childIndex}`}
                      className="block_goodColor__radio block_goodColor__black"
                    >
                      <span>{productAttributeItemVo}</span>
                    </label>
                  </div>
                ))}
          </div>
        </div>
      ))}
    </>
  );
};

export default ProductAttribute;
